import React, { useContext, useEffect, useState } from 'react'
import { StyledRecommendedJobOffers } from './styled'
import { API } from 'javascripts/api'
import MemberLayout from 'spa/member/layouts/MemberLayout/Index'
import { useLoggedIn } from 'spa/member/hooks/useLoggedIn'
import { decorate } from 'spa/member/decorators/jobOfferDecorator'
import { SessionContext } from 'spa/App'

const Index: React.FC = () => {
  const session = useContext(SessionContext)
  const loggedIn = useLoggedIn()
  const [jobOffersWithInfo, setJobOffersWithInfo] = useState([])

  const fetchJobOffers = async () => {
    const response = await API.getUserRecommendedJobOffers()

    setJobOffersWithInfo(decorate(response.data, session))
  }

  useEffect(() => {
    if (!loggedIn) {
      return
    }

    fetchJobOffers()
  }, [loggedIn])

  if (!loggedIn) {
    return null
  }

  return (
    <MemberLayout>
      <StyledRecommendedJobOffers jobOffersWithInfo={jobOffersWithInfo} />
    </MemberLayout>
  )
}

export default Index
